import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "header__top" }
const _hoisted_2 = { class: "container-fluid l2" }
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "col-auto batlantic"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "badlantic", -1)

import MenuInterface from '@/interfaces/MenuInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeaderTop',
  props: {
    items: {}
  },
  setup(__props: any) {



const batlanticIcon = window.ioappConfig.badlanticLogo;
const batlanticUrl = window.ioappConfig.badlanticUrl;

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (menuItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: menuItem.id,
            class: "col-auto"
          }, [
            _createVNode(_component_IoRouterLink, {
              "link-url": menuItem.url,
              "link-target": menuItem.target,
              "link-title": menuItem.titleAttr,
              active: menuItem.active
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: menuItem.title
                }, null, 8, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["link-url", "link-target", "link-title", "active"])
          ]))
        }), 128)),
        _hoisted_5,
        (_unref(batlanticUrl))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                href: _unref(batlanticUrl),
                target: "_blank"
              }, [
                _createElementVNode("img", { src: _unref(batlanticIcon) }, null, 8, _hoisted_8),
                _hoisted_9
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})